<div class="container">
    <!-- Title -->
    <h2>
        Dashboard
    </h2>

    <!-- inputs -->
    <form [formGroup]="form" class="inputs">

        <mat-form-field appearance="fill" size>
            <mat-label>Date From</mat-label>
            <input matInput [matDatepicker]="pickerFrom" formControlName="dateFrom" placeholder="DD/MMM/YYYY" />
            <mat-datepicker-toggle matPrefix [for]="pickerFrom"></mat-datepicker-toggle>
            <mat-datepicker #pickerFrom></mat-datepicker>
            <button mat-icon-button matSuffix (click)="clearDate('dateFrom')" *ngIf="form.get('dateFrom')?.value">
                <mat-icon>close</mat-icon>
            </button>
            <mat-error *ngIf="form.get('dateFrom')?.hasError('required') && form.get('dateFrom')?.touched">
                Start date is required
            </mat-error>
            <mat-error *ngIf="form.get('dateFrom')?.hasError('matDatepickerParse') && form.get('dateFrom')?.touched">
                Invalid date format
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>Date To</mat-label>
            <input matInput [matDatepicker]="pickerTo" formControlName="dateTo" placeholder="DD/MMM/YYYY" />
            <mat-datepicker-toggle matPrefix [for]="pickerTo"></mat-datepicker-toggle>
            <mat-datepicker #pickerTo></mat-datepicker>
            <button mat-icon-button matSuffix (click)="clearDate('dateTo')" *ngIf="form.get('dateTo')?.value">
                <mat-icon>close</mat-icon>
            </button>
            <mat-error *ngIf="form.get('dateTo')?.hasError('required') && form.get('dateTo')?.touched">
                End date is required
            </mat-error>
            <mat-error *ngIf="form.get('dateTo')?.hasError('matDatepickerParse') && form.get('dateTo')?.touched">
                Invalid date format
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>Notification</mat-label>
            <input matInput formControlName="notification"/>
            <button mat-icon-button matSuffix (click)="clearNotification()" *ngIf="form.get('notification')?.value">
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>Account</mat-label>
            <input matInput formControlName="account"/>
            <button mat-icon-button matSuffix (click)="clearAccount()" *ngIf="form.get('account')?.value">
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>Type</mat-label>
            <mat-select formControlName="type" multiple (selectionChange)="onTypeChange()">
                <mat-select-trigger>
                    {{ selectedRolesDisplay('type') }}
                </mat-select-trigger>
                <mat-option *ngFor="let type of types" [value]="type" [disabled]="isTypeDisabled(type)">{{ type }}</mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('type')?.hasError('required') && form.get('type')?.touched">
                Type is required
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>Account Status</mat-label>
            <mat-select formControlName="accountStatus" multiple (selectionChange)="onStatusChange()">
                <mat-select-trigger>
                    {{ selectedRolesDisplay('accountStatus') }}
                </mat-select-trigger>
                <mat-option *ngFor="let status of accountStatuses" [value]="status" [disabled]="isStatusDisabled(status)">{{ status }}</mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('accountStatus')?.hasError('required') && form.get('accountStatus')?.touched">
                Account Status is required
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>Country</mat-label>
            <mat-select formControlName="country" multiple (selectionChange)="onCountryChange()">
                <mat-select-trigger>
                    {{ selectedRolesDisplay('country') }}
                </mat-select-trigger>
                <mat-option *ngFor="let country of countries" [value]="country" [disabled]="isCountryDisabled(country)">{{ country }}</mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('country')?.hasError('required') && form.get('country')?.touched">
                Country is required
            </mat-error>
        </mat-form-field>
        
        <div *ngIf="form.hasError('dateRangeInvalid') && (form.get('dateFrom')?.touched || form.get('dateTo')?.touched)">
            <mat-error>'Date From' must be before or equal to 'Date To'</mat-error>
        </div>

    </form>

    <!-- Buttons -->
    <section class="buttons">
        <button mat-flat-button color="primary" [disabled]="form.invalid" (click)="search()">
            Search
        </button>

        <button mat-flat-button color="primary" [disabled]="form.invalid" (click)="onDownload()">
            Download
        </button>
    </section>

    <!-- Chart -->
    <section class="chart-container">
        <!-- Donut Charts Row -->
        <div class="donut-charts-row">
            <!-- Notification Type Chart -->
            <div class="chart-card">
                <h3>Notification type</h3>
                <div class="chart-wrapper">
                    <canvas #notificationTypeChart></canvas>
                    <div class="chart-center-value">{{ notificationTypeData.total }}</div>
                </div>
                <div class="chart-legend">
                    <div class="legend-item" *ngFor="let item of notificationTypeData.legend">
                        <span class="legend-color" [style.background-color]="item.color"></span>
                        <span>{{ item.label }} ({{ item.count }})</span>
                    </div>
                </div>
            </div>

            <!-- Account Status Chart -->
            <div class="chart-card">
                <h3>Account status</h3>
                <div class="chart-wrapper">
                    <canvas #accountStatusChart></canvas>
                    <div class="chart-center-value">{{ accountStatusData.total }}</div>
                </div>
                <div class="chart-legend">
                    <div class="legend-item" *ngFor="let item of accountStatusData.legend">
                        <span class="legend-color" [style.background-color]="item.color"></span>
                        <span>{{ item.label }} ({{ item.count }})</span>
                    </div>
                </div>
            </div>

            <!-- Account Delivery Chart -->
            <div class="chart-card">
                <h3>Account delivery</h3>
                <div class="chart-wrapper">
                    <canvas #accountDeliveryChart></canvas>
                    <div class="chart-center-value">{{ accountDeliveryData.total }}</div>
                </div>
                <div class="chart-legend">
                    <div class="legend-item" *ngFor="let item of accountDeliveryData.legend">
                        <span class="legend-color" [style.background-color]="item.color"></span>
                        <span>{{ item.label }} ({{ item.count }})</span>
                    </div>
                </div>
            </div>

            <!-- Account Feedback Chart -->
            <div class="chart-card">
                <h3>Account feedback</h3>
                <div class="chart-wrapper">
                    <canvas #accountFeedbackChart></canvas>
                    <div class="chart-center-value">{{ accountFeedbackData.total }}</div>
                </div>
                <div class="chart-legend">
                    <div class="legend-item" *ngFor="let item of accountFeedbackData.legend">
                        <span class="legend-color" [style.background-color]="item.color"></span>
                        <span>{{ item.label }} ({{ item.count }})</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Bar Chart -->
        <div class="bar-chart-container">
            <h3>Notifications by month</h3>

            <div class="bar-chart-wrapper">
                <canvas #monthlyChart></canvas>
            </div>
        </div>
    </section>

    <!-- Table -->
    <section>
        <dl-dashboard-table [dbTableData]="dbTableData"></dl-dashboard-table>
    </section>
</div>